<template>
  <div class="landing-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="" style="text-align: center">
            <img style="width: 35%;margin-top: 50px" src="../../static/images/logo.png">
          </div>
          <div class="middle">
            <img src="../../static/images/login_pic1.png">
          </div>
          <div class="login-overlay">
            <div class="ac mt30 por">
              <button class="login-button" @click="handleLogin" type="button">
                <span class="login-button-image login-en" ></span>
                <span class="login-button-text">{{ $t('Login') }}</span>
              </button>
            </div>
          </div>
          <div class="ac otp-b disflex por login-footer">
            <div class="icon icon2 login_help" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
            <div class="icon icon2 login_help" @click="getChange('faq')">{{ $t('FAQ') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isEN: "bur",
    }
  },
  created() {
    if (localStorage.getItem('lang')) {
      this.isEN = localStorage.getItem('lang');
    }
  },
  methods: {
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    handleLogin() {
      let url = "https://tshe.gbgts.com/arrow/consent/page";
      // 获取当前页面 URL 的参数
      const params = new URLSearchParams(window.location.search);
      // 追加当前页面的所有参数
      const targetUrl = new URL(url);
      params.forEach((value, key) => {
        targetUrl.searchParams.set(key, value);
      });
      // 跳转
      window.location.href = targetUrl.toString();
    },
  }
}
</script>
<style scoped>
.landing-page {
  min-height: 100vh;
  background-size: cover !important;
}

.otp-b {
  justify-content: space-evenly;
}

.login-overlay {
  z-index: 10;
}

.middle img {
  top: 300px !important;
  width: 520px !important;
  max-width: 90% !important;
}

.input-div input.input::placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.input-div .input-item {
  width: 86% !important;
  height: 76px !important;
  border-radius: 60px !important;
  margin: 0 auto !important;
}

.input-div .input-item2 {
  height: 76px !important;
  border-radius: 60px !important;
}

.input-div .app-en {
  padding: 0 !important;
  margin-right: 10px;
}

.input-div .app-en img {
  width: 120px !important;
  height: auto;
  display: inline-block;
}

.input-div input.input {
  height: 76px !important;
  line-height: 76px !important;
  font-size: 42px !important;
  font-weight: 700 !important;
  padding: 0 25px !important;
  margin: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-sizing: border-box;
  width: 100%;
}

.login-button {
  position: relative;
  width: min(320px, 80vw);
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.login-button-image {
  display: block;
  width: 100%;
  aspect-ratio: 53 / 22;
  margin: 0 auto;
  background-size: 100% 100% !important;
}

.login-button-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);

  color: #ffffff;
  font-size: 35px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap !important;
  -webkit-text-stroke: 1px #813000;
  text-shadow:
    2px 3px 0 #813000,
    0 4px 5px rgba(0, 0, 0, 0.4);
  pointer-events: none;
}

.login-en {
  background: url(../../static/images/daily-bg_en.png) no-repeat center !important;
}

.login-mm {
  background: url(../../static/images/login_mm.png) no-repeat center !important;
}

.login-footer {
  margin-top: 270px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/land.vue